export default __webpack_public_path__ + "static/media/ce-2.7ac17a49.png";